import React from 'react';
import TechPill from './TechPill';

function ExperienceItem({ 
    date, 
    role, 
    company, 
    companyUrl, 
    projectUrl,
    location, 
    description, 
    skills = [] 
}) {
    const url = projectUrl || companyUrl;

    return (
        <div className="experience-item">
            <div className="date">{date}</div>
            <div className="role-details">
                <h3>
                    {role} · {url ? (
                        <a 
                            href={url} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="company-link"
                            onClick={(e) => e.stopPropagation()} 
                        >
                            {company}
                        </a>
                    ) : (
                        company
                    )}
                </h3>
                <div className="location">{location}</div>
                <p>{description}</p>
                <div className="tech-list">
                    {skills.map((skill, index) => (
                        <TechPill key={index} tech={skill} />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ExperienceItem; 